/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const mockUserDtoSchema = z.object({
  userId: z.coerce.number().int(),
  name: z.coerce.string(),
  dailyHours: z.coerce.number().int(),
});
